<form (submit)="save()" [formGroup]="form">
    <h1 mat-dialog-title>{{ 'Components.SearchFilter.SaveFilter' | transloco }}</h1>
    <mat-dialog-content>
        <div class="flex flex-col gap-2 pt-2">
            <arc-input [control]="form.controls.name" labelKey="Components.SearchFilter.FilterName" />
            <arc-checkbox [control]="form.controls.isDefaultFilter" labelKey="Components.SearchFilter.UseAsDefaultFilter" />
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close>{{ 'General.Actions.Cancel' | transloco }}</button>
        <button mat-flat-button type="submit" color="accent">{{ 'General.Actions.Save' | transloco }}</button>
    </mat-dialog-actions>
</form>
